// Brand
export const GET_BRANDS = "marketplace/admin/getBrands";
export const ADD_BRANDS = "marketplace/admin/addBrand";
export const DELETE_BRANDS = "marketplace/admin/deleteBrand";
export const ACTIVE_BRANDS = "marketplace/admin/makeActiveBrand";
export const EDIT_BRANDS = "marketplace/admin/editBrand";

// Category
export const GET_CATEGORY = "marketplace/admin/getCategories";
export const ADD_CATEGORY = "marketplace/admin/addCategory";
export const DELETE_CATEGORY = "marketplace/admin/deleteCategory";
export const ACTIVE_CATEGORY = "marketplace/admin/makeActiveCategory";
export const EDIT_CATEGORY = "marketplace/admin/editCategory";

// SubCategory
export const GET_SUBCATEGORY = "marketplace/admin/getSubCategories";
export const ADD_SUBCATEGORY = "marketplace/admin/addSubCategory";
export const DELETE_SUBCATEGORY = "marketplace/admin/deleteSubCategory";
export const ACTIVE_SUBCATEGORY = "marketplace/admin/makeActiveSubCategory";
export const UPDATE_SUBCATEGORY = "marketplace/admin/editSubCategory";

//Product

export const GET_PRODUCTS = "marketplace/admin/getProducts";
export const GET_PRODUCT_BY_ID = "marketplace/admin/getProductById";
export const ADD_PRODUCTS = "marketplace/admin/addProductCategory";
export const DELETE_PRODUCTS = "marketplace/admin/deleteProduct";
export const ACTIVE_PRODUCTS = "marketplace/admin/makeActiveProduct";

export const UPDATE_PRODUCT_ADDITION_DETAILS =
    "/marketplace/admin/updateProductAdditionalDetail";
export const UPDATE_PRODUCT_DOC = "marketplace/admin/uploadProductDocuments";
export const UPDATE_PRODUCT_DETAILS = "marketplace/admin/updateProductDetails";
export const UPDATE_INFO_PRODUCT = "marketplace/admin/updateProductInformation";
export const UPDATE_ADDITIONAL_INFO_PRODUCT =
    "marketplace/admin/updateProductAdditionalInformation";
export const UPDATE_PRODUCT_PRICE = "marketplace/admin/updateProductPrices";

export const GET_SPEND_TRACKER = "admin/getSpendTrackerCategory";
export const ADD_SPEND_TRACKER = "admin/addSpendTrackerCategory";
export const UPDATE_SPEND_TRACKER = "admin/editSpendTrackerCategory";
export const DELETE_SPEND_TRACKER = "admin/deleteSpendTrackerCategory";
export const ACTIVE_SPEND_TRACKER = "admin/makeActiveSpendTrackerCategory";

// FAQ

export const ADD_FAQ_SECTION = "admin/addFaq";
export const EDIT_FAQ_SECTION = "admin/editFaq";
export const DELETE_FAQ_SECTION = "/admin/deleteFaq";
export const GET_FAQ_SECTION = "admin/getFaq";
export const ACTIVE_FAQ_SECTION = "admin/makeActiveFaq";

export const ADD_VIDEO_INSIGHT = "marketplace/admin/addFeatureVideo";
export const EDIT_VIDEO_INSIGHT = "marketplace/admin/editFeatureVideo";
export const DELETE_VIDEO_INSIGHT = "marketplace/admin/makeActiveFeatureVideo";
export const GET_VIDEO_INSIGHT = "/marketplace/admin/getFeatureVideo";
export const ACTIVE_VIDEO_INSIGHT = "marketplace/admin/makeActiveFeatureVideo";

// Banner
export const GET_BANNERS = "marketplace/admin/getBanners";
export const ADD_BANNER = "marketplace/admin/addBanner";
export const DELETE_BANNER = "marketplace/admin/deleteBanner";
export const ACTIVE_BANNER = "marketplace/admin/makeActiveBanner";
export const EDIT_BANNER = "marketplace/admin/editBanner";

// Coupon
export const GET_COUPON = "marketplace/admin/getCoupons";
export const ADD_COUPON = "marketplace/admin/addCoupon";
export const DELETE_COUPON = "marketplace/admin/deleteCoupon";
export const ACTIVE_COUPON = "marketplace/admin/makeActiveCoupon";
export const EDIT_COUPON = "marketplace/admin/editCoupon";

// Custom Goal

export const GET_CUSTOM_GOAL = "marketplace/admin/getCustomGoals";
export const ADD_CUSTOM_GOAL = "marketplace/admin/addCustomGoal";
export const DELETE_CUSTOM_GOAL = "marketplace/admin/deleteCustomGoal";
export const ACTIVE_CUSTOM_GOAL = "marketplace/admin/makeActiveCustomGoal";
export const EDIT_CUSTOM_GOAL = "marketplace/admin/editCustomGoal";

// Goal Category
export const GET_GOAL_CATEGORY = "marketplace/admin/getGoalCategory";
export const ADD_GOAL_CATEGORY = "marketplace/admin/addGoalCategory";
export const DELETE_GOAL_CATEGORY = "marketplace/admin/deleteGoalCategory";
export const ACTIVE_GOAL_CATEGORY = "marketplace/admin/makeActiveGoalCategory";
export const EDIT_GOAL_CATEGORY = "marketplace/admin/editGoalCategory";

// Boarding
export const UPDATE_BOARDING = "admin/addQuesAndAns";
export const GET_BOARDING = "admin/getQuesAndAns";
export const EDIT_BOARDING = "admin/editQuesAndAns";
export const ACTIVE_BOARDING = "admin/makeActiveQuesAndAns";
export const DELETE_BOARDING = "admin/deleteQuesAndAns";

// Admin management
export const GET_ADMINS = "admin/getAdmins";
export const UPDATE_ADMIN = "admin/updateAdmin";
export const DELETE_ADMIN = "admin/deleteAdmin";
export const ADMIN_PROFILE = "admin/profile";

// Roles & permissions (RBAC)
export const MY_ACCESS = "admin/access";
export const ROLES = "admin/roles";
export const PERMISSION_CATALOG = "admin/roles/catalog";

// App users (roster + activity)
export const GET_USERS = "admin/getUsers";
export const GET_USER_ACTIVITY = "admin/getUserActivity";
// Account deletion requests (filed in the app; soft-deleted or cancelled here)
export const GET_ACCOUNT_DELETION_REQUESTS = "admin/getAccountDeletionRequests";
export const GET_ACCOUNT_DELETION_REQUEST = "admin/getAccountDeletionRequest";
export const COMPLETE_ACCOUNT_DELETION = "admin/completeAccountDeletion";
export const CANCEL_ACCOUNT_DELETION = "admin/cancelAccountDeletion";
// Launch waitlist (website sign-ups) - backend/docs/WAITLIST.md
export const WAITLIST = "waitlist/admin";
export const WAITLIST_STATS = "waitlist/admin/stats";
export const WAITLIST_EXPORT = "waitlist/admin/export";

// Notifications (push + in-app)
export const SEND_USER_NOTIFICATION = "admin/sendUserNotification";
export const SEND_BULK_NOTIFICATION = "admin/sendBulkNotification";
export const GET_NOTIFICATION_CAMPAIGNS = "admin/notificationCampaigns";
export const GET_NOTIFICATION_CAMPAIGN = "admin/notificationCampaign";

// Bulk import / export
export const GET_BULK_JOB_STATUS = "admin/bulkJobStatus";
export const BULK_UPLOAD_PRODUCTS = "marketplace/admin/bulkUploadProducts";
export const BULK_UPLOAD_BRANDS = "marketplace/admin/bulkUploadBrands";
export const BULK_UPLOAD_CATEGORIES = "marketplace/admin/bulkUploadCategories";
export const BULK_UPLOAD_SUBCATEGORIES =
    "marketplace/admin/bulkUploadSubCategories";
export const BULK_UPLOAD_COUPONS = "marketplace/admin/bulkUploadCoupons";
export const BULK_UPLOAD_BANNERS = "marketplace/admin/bulkUploadBanners";
export const BULK_UPLOAD_GOAL_CATEGORIES =
    "marketplace/admin/bulkUploadGoalCategories";
export const BULK_UPLOAD_CUSTOM_GOALS =
    "marketplace/admin/bulkUploadCustomGoals";
export const BULK_UPLOAD_FEATURE_VIDEOS =
    "marketplace/admin/bulkUploadFeatureVideos";
export const BULK_UPLOAD_FAQ = "admin/bulkUploadFaq";
export const BULK_UPLOAD_QUES_AND_ANS = "admin/bulkUploadQuesAndAns";
export const BULK_UPLOAD_SPEND_TRACKER =
    "admin/bulkUploadSpendTrackerCategories";

export const EXPORT_PRODUCTS = "marketplace/admin/exportProducts";
export const EXPORT_BRANDS = "marketplace/admin/exportBrands";
export const EXPORT_CATEGORIES = "marketplace/admin/exportCategories";
export const EXPORT_SUBCATEGORIES = "marketplace/admin/exportSubCategories";
export const EXPORT_COUPONS = "marketplace/admin/exportCoupons";
export const EXPORT_BANNERS = "marketplace/admin/exportBanners";
export const EXPORT_GOAL_CATEGORIES = "marketplace/admin/exportGoalCategories";
export const EXPORT_CUSTOM_GOALS = "marketplace/admin/exportCustomGoals";
export const EXPORT_FEATURE_VIDEOS = "marketplace/admin/exportFeatureVideos";
export const EXPORT_FAQ = "admin/exportFaq";
export const EXPORT_QUES_AND_ANS = "admin/exportQuesAndAns";
export const EXPORT_SPEND_TRACKER = "admin/exportSpendTrackerCategories";

// Blog - Category
export const GET_BLOG_CATEGORY = "blog/admin/getCategories";
export const ADD_BLOG_CATEGORY = "blog/admin/addCategory";
export const EDIT_BLOG_CATEGORY = "blog/admin/editCategory";
export const DELETE_BLOG_CATEGORY = "blog/admin/deleteCategory";
export const ACTIVE_BLOG_CATEGORY = "blog/admin/makeActiveCategory";

// Blog - Sub-category
export const GET_BLOG_SUBCATEGORY = "blog/admin/getSubCategories";
export const ADD_BLOG_SUBCATEGORY = "blog/admin/addSubCategory";
export const EDIT_BLOG_SUBCATEGORY = "blog/admin/editSubCategory";
export const DELETE_BLOG_SUBCATEGORY = "blog/admin/deleteSubCategory";

// Blog - Post
export const GET_BLOG_POSTS = "blog/admin/getPosts";
export const GET_BLOG_POST = "blog/admin/getPost";
export const ADD_BLOG_POST = "blog/admin/addPost";
export const EDIT_BLOG_POST = "blog/admin/editPost";
export const DELETE_BLOG_POST = "blog/admin/deletePost";
export const ACTIVE_BLOG_POST = "blog/admin/makeActivePost";
export const UPLOAD_BLOG_POST_IMAGE = "blog/admin/uploadPostImage";

// Blog - Comments
export const GET_BLOG_COMMENTS = "blog/admin/getComments";
export const MODERATE_BLOG_COMMENT = "blog/admin/moderateComment";
export const DELETE_BLOG_COMMENT = "blog/admin/deleteComment";

// Analytics
export const ANALYTICS_OVERVIEW = "admin/analytics/overview";
export const ANALYTICS_USERS = "admin/analytics/users";
export const ANALYTICS_GOALS = "admin/analytics/goals";
export const ANALYTICS_PURCHASES = "admin/analytics/purchases";
export const ANALYTICS_SPEND_TRACKER = "admin/analytics/spend-tracker";
export const ANALYTICS_SUPPORT = "admin/analytics/support";

// Assistant insights - what people ask the AI assistant, and the answers added from it
export const ASSISTANT_INSIGHTS = "admin/assistant/insights";
export const ASSISTANT_ANSWERS = "admin/assistant/answers";
export const ASSISTANT_ADD_ANSWER = "admin/assistant/addAnswer";

// Rewards - coupons (Coupontools) and scratch card rules
export const REWARDS_STATS = "rewards/admin/getStats";
export const REWARDS_CAMPAIGNS = "rewards/admin/getCampaigns";
export const REWARDS_ADD_OFFERS = "rewards/admin/addOffers";
export const REWARDS_ADD_OWN_PRIZE = "rewards/admin/addOwnPrize";
export const REWARDS_OFFERS = "rewards/admin/getOffers";
export const REWARDS_EDIT_OFFER = "rewards/admin/editOffer";
export const REWARDS_SYNC_OFFERS = "rewards/admin/syncOffers";
export const REWARDS_DELETE_OFFER = "rewards/admin/deleteOffer";
export const REWARDS_ISSUED_COUPONS = "rewards/admin/getIssuedCoupons";
export const REWARDS_VOID_COUPON = "rewards/admin/voidCoupon";
export const REWARDS_RETRY_COUPON = "rewards/admin/retryCoupon";
export const REWARDS_RULE_EVENTS = "rewards/admin/getRuleEvents";
export const REWARDS_RULES = "rewards/admin/getRules";
export const REWARDS_ADD_RULE = "rewards/admin/addRule";
export const REWARDS_EDIT_RULE = "rewards/admin/editRule";
export const REWARDS_DELETE_RULE = "rewards/admin/deleteRule";
export const REWARDS_SCRATCH_CARDS = "rewards/admin/getScratchCards";

// Refer & Earn - who referred whom, and reversing a referral
// (backend/src/modules/referrals/admin.routes.ts). Reverse is `${REFERRALS_ADMIN}/:id/reverse`.
export const REFERRALS_ADMIN = "referrals/admin";

// Recharge & Bills - convenience fee rules, settings, orders and invoices (backend/docs/BILLPAY.md)
export const BILLPAY_CHARGE_RULES = "billpay/admin/getChargeRules";
export const BILLPAY_ADD_CHARGE_RULE = "billpay/admin/addChargeRule";
export const BILLPAY_EDIT_CHARGE_RULE = "billpay/admin/editChargeRule";
export const BILLPAY_ACTIVE_CHARGE_RULE = "billpay/admin/makeActiveChargeRule";
export const BILLPAY_DELETE_CHARGE_RULE = "billpay/admin/deleteChargeRule";
export const BILLPAY_CHARGE_PREVIEW = "billpay/admin/getChargePreview";
export const BILLPAY_SETTINGS = "billpay/admin/getSettings";
export const BILLPAY_EDIT_SETTINGS = "billpay/admin/editSettings";
export const BILLPAY_ORDERS = "billpay/admin/getOrders";
export const BILLPAY_ORDER = "billpay/admin/getOrder";
export const BILLPAY_RETRY_REFUND = "billpay/admin/retryRefund";
export const BILLPAY_COMPLETE_REVIEW = "billpay/admin/completeOrderReview";
export const BILLPAY_SEND_INVOICE = "billpay/admin/sendInvoice";
export const BILLPAY_STATS = "billpay/admin/getStats";
export const BILLPAY_INVOICES = "billpay/admin/getInvoices";
export const BILLPAY_INVOICE_SUMMARY = "billpay/admin/getInvoiceSummary";
export const BILLPAY_DOWNLOAD_INVOICE = "billpay/admin/downloadInvoice";
export const BILLPAY_EXPORT_INVOICES = "billpay/admin/exportInvoices";

// Gift-voucher offers: % off per brand (backend/docs/VOUCHERS.md, "Offers")
export const VOUCHER_OFFERS = "vouchers/admin/getOffers";
export const VOUCHER_EDIT_OFFER = "vouchers/admin/editOffer";
